import React, { useState } from "react";
import "./Reportes.css";
import authContext from "../../context/authentication/authContex";
import { useContext } from "react";
import GrillaEstadisticaReq from "../../components/grillasReportes/GrillaEstadisticaReq";

const Reportes = () => {
  const aContext = useContext(authContext);
  const { usuario } = aContext;
  const [gridToShow, setGridToShow] = useState("");

  return (
    <div className={gridToShow ? "reportesView reportesView--full" : "reportesView"}>
      {!gridToShow && (
        <div className="multipleOptionsDiv">
          <div className="optionDiv">
            <button onClick={() => setGridToShow("ESTADISTICA_REQ")}>
              Estadística de Requerimientos
            </button>
          </div>
        </div>
      )}
      {gridToShow === "ESTADISTICA_REQ" && (
        <GrillaEstadisticaReq setGridToShow={setGridToShow} usuario={usuario} />
      )}
    </div>
  );
};

export default Reportes;
